import React from 'react';
import Image from 'next/image';

const getotherProps = (data) =>
    Object.keys(data).reduce((accum, name) => {
        if (name !== 'childrenRef') {
            accum[name] = data[name];
        } else {
            accum.ref = data[name];
        }

        return accum;
    }, {});

const getSrc = (src) => {
    if (!process.env.NEXT_PUBLIC_DOMAINS) return src;
    const array = process.env.NEXT_PUBLIC_DOMAINS.split('|');
    let newSrc = src;
    if (typeof window != 'undefined') {
        let URL = array.find((d) => (process.env.NEXT_PUBLIC_ISCOPY ? 'ut.' : '') + d === window.location.host);
        if (URL && URL !== array[0]) {
            newSrc = src.replace(array[0], URL);
        }
    }
    return newSrc;
};

export const WebImage = (props) => {
    let { style } = props;
    let otherProps = getotherProps(props);

    const width = props.width || props.style?.width;
    const height = props.height || props.style?.height;
    if (typeof props.src === 'object') {
        if (typeof width === 'number' && typeof height === 'number') {
            otherProps.width = width;
            otherProps.height = height;
        } else if (width?.includes('px') && height?.includes('px')) {
            otherProps.width = width;
            otherProps.height = height;
        } else if (!props?.className) {
            if (!style) {
                style = {};
            }
            if (!style?.width) {
                style.width = 'auto';
            }
            if (!style?.height) {
                style.height = 'auto';
            }
        }
        return <Image {...otherProps} alt={props.alt || ''} />;
    }
    if (otherProps.src) {
        otherProps.src = getSrc(otherProps.src);
    }
    if (typeof width === 'number' && typeof height === 'number') {
        otherProps.width = width;
        otherProps.height = height;
        return <Image {...otherProps} alt={props.alt || ''} />;
    } else if (width?.includes('px') && height?.includes('px')) {
        otherProps.width = width;
        otherProps.height = height;
        return <Image {...otherProps} alt={props.alt || ''} />;
    } else {
        // eslint-disable-next-line @next/next/no-img-element
        return <img {...otherProps} alt={props.alt || ''} />;
    }
};
